import { Language, LocalizationKey } from "../../localization/Localization";
import { injectable } from "@launchtray/tsyringe-async";
import { LocalizationResourcesPackage } from "../../localization/LocalizationResourcesPackage";
import { SettingsModel } from "./SettingsModel";

type LocalizationConfig = Record<LocalizationKey, string>;

@injectable()
export class LocalizationModel {
    private static readonly DEFAULT_CONFIG: keyof LocalizationResourcesPackage = "assets_localization_en_json";
    private static readonly LOCALIZATION_CONFIG: Record<Language, keyof LocalizationResourcesPackage> = {
        en: "assets_localization_en_json",
        fr: "assets_localization_fr_json",
        es: "assets_localization_es_json",
        de: "assets_localization_de_json",
        it: "assets_localization_it_json",
        ja: "assets_localization_ja_json",
        ru: "assets_localization_ru_json",
        pl: "assets_localization_pl_json",
        cs: "assets_localization_cs_json"
    };

    public constructor(
        private readonly localizationResources: LocalizationResourcesPackage,
        private readonly settingsModel: SettingsModel
    ) {
    }

    public getText(key: LocalizationKey): string {
        const localizationConfigKey = LocalizationModel.LOCALIZATION_CONFIG[this.settingsModel.language.value];
        const config = this.localizationResources[localizationConfigKey] as LocalizationConfig;
        if (!(key in config)) {
            console.warn(`Not found key ${key} for ${this.settingsModel.language.value} configuration, used default config`);
            const defaultConfig = this.localizationResources[LocalizationModel.DEFAULT_CONFIG] as LocalizationConfig;
            return defaultConfig[key];
        }
        return config[key];
    }
}